import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import { ComponentItem } from "designSystem/types/component-item-types";
import { FlexRowCenter } from "designSystem/components/flex/FlexRowCenter";
import { useLocale } from "designSystem/locale";
import Select from "designSystem/components/select/Select";
import OverflowText from "designSystem/components/text/OverflowText";
import { DataSetupSection } from "csi/state/datasetup";
import React, { FunctionComponent, ReactNode } from "react";

const PREFIX = "SectionSwitcher";

const classes = {
	menuIcon: `${PREFIX}menuIcon`,
};

const StyledSelect = styled(Select)((
	{
		theme,
	},
) => ({
	[`& .${classes.menuIcon}`]: {
		marginRight: 4,
	},
}));

interface SectionSwitcherProps {
	/** the active section in the list */
	activeSection: DataSetupSection;

	/** sections which will be in the list */
	sections: DataSetupSection[];
}

/**
 * Convert the section into the item
 */
export function convertSectionToItem(section: DataSetupSection): ComponentItem {
	const { id, name, href } = section;
	return { id, name, href };
}

const SectionSwitcher: FunctionComponent<SectionSwitcherProps> = (props) => {
	const { sections, activeSection, ...otherProps } = props;


	const items = sections.map((section) => convertSectionToItem(section));
	const activeItem = convertSectionToItem(activeSection);


	const renderSelectedItemFunc = (item: ComponentItem): ReactNode => {
		const text = useLocale().getComponentItemName(item);

		return (
			<FlexRowCenter>
				<MenuIcon className={classes.menuIcon} color="action" />
				<OverflowText
					bold
					text={text}
					tooltipProps={{ placement: "right" }}
				/>
			</FlexRowCenter>
		);
	};

	return (
		<StyledSelect
			constrainMenuWidth
			fullWidth
			items={items}
			renderSelectedItemFunc={renderSelectedItemFunc}
			secondary
			selectedItem={activeItem}
			{...otherProps}
		/>
	);
};

export default SectionSwitcher;